import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { BasePage } from 'src/app/core/base-page';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { BrowserHelper } from 'src/app/core/helper/browser.helper';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { Community } from 'src/app/data/schema/community';
import { RegisterRequest } from 'src/app/core/modules/auth-core/data/schema/auth-models';
import { CommunityService } from 'src/app/data/service/community.service';
import { Log } from 'src/app/core/log';

@Component({
  selector: 'app-login-embed',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginEmbedComponent extends BasePage {

  @Input() redirectOnLogin: boolean = true;

  @Output() loginSuccessful = new EventEmitter();

  view: LoginView = LoginView.login;

  emailForForgot: string;

  constructor(
    authService: AuthenticationService,
    private browserHelper: BrowserHelper,
    private communityService: CommunityService,
    private menuCtrl: MenuController) {
    super(authService);

    menuCtrl.enable(false);
  }

  get version() { return AppSettings.version; }
  get currentYear() { return AppSettings.currYear; }
  get loginView() { return LoginView; }

  async loginComplete() {
    Log.debug('login complete...')
    try {
      // clear saved username from registration once successfully logged in
      if (localStorage.getItem('afafdawceth54') != null) {
        localStorage.removeItem('afafdawceth54');
        localStorage.removeItem('jhr5trg34fgwe');
      }

      if (this.redirectOnLogin) {
        let community = null;
        // in the case of the onboarding, new user creating community wizard, we wouldn't want 
        // to do any redirect.
        var hasCommunity = false;
        if (localStorage.getItem('curr_community') != null) {
          // if we accessed a community before, set that community as active and 
          // go to engagement dashboard.
          await this.communityService.loadCommunity(+localStorage.getItem('curr_community'));
          hasCommunity = true;
        } else {
          // not in an active community yet, load users communities communities
          const myCommunities = await Community.getMyCommunities();
          if (myCommunities.length == 1) {
            // we have exactly one community, set it as active and go to dash
            await this.communityService.loadCommunity(myCommunities[0].communityId);
            localStorage.setItem('curr_community', myCommunities[0].communityId.toString());
            hasCommunity = true
          } else {
            // else they have no, or many communities, go to communities list page
            await ServiceHelper.navCtrl.navigateRoot('/home/communities');
          }
        }

        // if we have a community, check if template selection has been completed, 
        // and if not, redirect to complete the community setup wizard
        if (hasCommunity) {
          if (Community.activeCommunity == null) {
            // huh, no active community found? go to new community to create
            Log.debug('LoginComplete - community was loaded, but active community not set, take to new community wizard (shouldnt happen) ');
            await ServiceHelper.navCtrl.navigateRoot('/home/new-community');
          } else if (Community.activeCommunity.templatesAdded == null) {
            // finish setup
            Log.debug('LoginComplete - users community was loaded, but templates still unset, take to new community to finish ');
            await ServiceHelper.navCtrl.navigateRoot('/home/new-community/' + Community.activeCommunity.communityId);
          } else {
            Log.debug('LoginComplete - users community was loaded, take to engagement dashboard ');
            await ServiceHelper.navCtrl.navigateRoot('/engagement/dashboard');
            this.menuCtrl.enable(true);
          }
        }
      }
      this.loginSuccessful.emit();

      //this.runAnalytics();
    } catch (error: any) {
      // if the error contains "ChunkLoadError" then we need to reload the page put throw a random timestamp to avoid cache issues
      if (error.message.includes('ChunkLoadError')) {
        ServiceHelper.displayAlert('Error During Login', 'A page error occurred. Please try again.');
        window.location.reload();
      } else {
        ServiceHelper.displayAlert('Error During Login', error);
        console.error('Error during login. Error: ', error);
        this.pageState.busy = false;
      }
    }
  }

  async registerComplete(registerModel: RegisterRequest) {
    // ServiceHelper.displayAlert('Registration Successful!', 'You can now login with your new account.');
    // this.view = LoginView.login;

    var load = await ServiceHelper.displayLoad('Registration successfull, logging you in...')
    await this.authService?.login(registerModel);
    await this.loginComplete();
    load.dismiss();
  }

  registerClicked(email: string) {
    this.view = LoginView.register
    this.emailForForgot = email;
  }

  forgotPassword(email: string) {
    this.view = LoginView.requestReset
    this.emailForForgot = email;
  }

  openTerms() {
    this.browserHelper.openUrl('https://bidbeacon.com/terms-of-service/');
  }

  openPrivacy() {
    this.browserHelper.openUrl('https://bidbeacon.com/privacy-policy/');
  }

}

export enum LoginView {
  login = 1,
  register = 2,
  requestReset = 3
}
